import React from 'react';
import { Button, Flex, Link } from '@upgrade/react-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { ArticleContainer, ContainerRelatedArticle, ImageContainer, ArticleLink, ExternalArticleLink } from './styles';
import { Heading, Text } from '../TypographyPublicSite';
import { EXTERNAL_ARTICLE } from '../../../cms/widgets/common/related-articles/constants';
import { ResponsiveImage } from '../styles';

const RelatedPostLink = ({ slug, title, image, imageSrc, time, imgHeight, type }) => (
  <li>
    <Link
      anchorComponent={type === EXTERNAL_ARTICLE ? ExternalArticleLink : ArticleLink}
      {...(type === EXTERNAL_ARTICLE ? { href: slug, openInNewWindow: true } : { to: slug })}
    >
      <ImageContainer $imgHeight={imgHeight}>
        {image ? <GatsbyImage image={image} alt="" /> : <ResponsiveImage src={imageSrc} alt="" />}
      </ImageContainer>
      <Text color="actionableSecondary" as="p" weight="500" size="md" marginBottom="none">
        {title}
      </Text>
      <Text as="p" size="xxs" color="contentWeak">
        {time} minute read
      </Text>
    </Link>
  </li>
);

const RelatedArticles = ({
  title = 'Related Articles',
  subtitle,
  relatedArticles = [],
  bottom = false,
  imgHeight,
  ctaLinkUrl
}) => (
  <ContainerRelatedArticle $bottom={bottom}>
    <Heading as="h2" align="center" marginBottom={subtitle ? 'md' : 'xl'} size="sm">
      {title}
    </Heading>
    {subtitle && (
      <Text as="div" align="center" marginBottom="xl" size="md" color="contentWeak">
        {subtitle}
      </Text>
    )}
    <ArticleContainer className="list-links list--unstyled" $bottom={bottom}>
      {relatedArticles.slice(0, bottom ? 3 : 2).map(({ id, ...rest }) => (
        <RelatedPostLink key={id} {...{ ...rest, imgHeight }} />
      ))}
    </ArticleContainer>
    {ctaLinkUrl ? (
      <Flex justify="center" mt="lg">
        <Button emphasis="tertiary" href={ctaLinkUrl}>
          See More Articles
        </Button>
      </Flex>
    ) : null}
  </ContainerRelatedArticle>
);

export default RelatedArticles;
